<template>
  <section class="technologies-wrapper">
    <div class="container technologies">
      <div v-for="(technology) in technologies" :key="technology.icon" class="logo">
        <component
          :is="icon(technology.icon)"
          :class="technology.icon"
        />
        <span v-if="technology.text" class="text">
          {{ technology.text }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    technologies: { type: Array, default: () => ([]), required: true },
  },
  methods: {
    icon(icon) {
      // eslint-disable-next-line import/no-dynamic-require
      return icon ? require(`../assets/svg/tech-${icon}.svg?vue-component`) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.technologies-wrapper {
  padding: 34px 0;
  background: var(--main-dark-light-1);

  .technologies {
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-16) 0;
    color: var(--main-light-shade-3);
    font-size: 14px;

    .logo {
      display: flex;
      align-items: center;

      svg {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }
  }
}

@include bp($bp-laptop) {
  .technologies .logos .logo svg {
    height: 21px;
  }
}

@include bp($bp-mobile) {
  .technologies {
    display: block;
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 80px;

    .title {
      margin: var(--spacing-40) auto var(--spacing-40);
      width: 100%;
      flex: 0 0 100%;
      text-align: center;
    }

    .logos {
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 16px;
      column-gap: 40px;

      .logo svg {
        width: auto;
        height: 25px;
      }
    }
  }
}
</style>
